export const en = {
    'active-status': 'Active',
    'age-limit': 'Age restricted information products',
    'archived-status': 'Archived',
    'audio-creatives': 'Audio creatives',
    'banner-adaptive-image': 'Adaptive',
    'banner-body': 'The text of your ad for a product or services.',
    'banner-domain': 'domain',
    'banner-href-choose-protocol': 'Choose the protocol',
    'banner-href-domain-invalid': 'Invalid domain format',
    'banner-href-http-invalid': 'Your server returned the following error: 404 Not Found',
    'banner-href-http-timeout': 'Your server returned the following error: 400 unavailable',
    'banner-href-invalid': 'Incorrect link format',
    'banner-href-null': 'Link cannot be empty',
    'banner-price': 'Prices in ads',
    'banner-title': 'Ad title',
    'banner-type-content-promotion-collection': 'Yandex Collection promotion',
    'banner-type-content-promotion-video': 'Yandex Video promotion',
    'banner-type-cpc_video': 'Video',
    'banner-type-cpm-indoor': 'Indoor advertising',
    'banner-type-cpm_audio': 'Audio',
    'banner-type-cpm_banner': 'Media banner',
    'banner-type-cpm_geoproduct': 'Banner in Yandex.Metro',
    'banner-type-cpm_geoproduct-new': 'Banner on geo sites',
    'banner-type-cpm_outdoor': 'Outdoor advertising',
    'banner-type-cpm_video': 'Display video',
    'banner-type-dynamic': 'Dynamic ad',
    'banner-type-image_ad': 'Graphic ad',
    'banner-type-internal': 'Internal ad',
    'banner-type-internal-autobudget': 'Auto-budget campaign',
    'banner-type-internal-distrib': 'Distribution ad',
    'banner-type-internal-free': 'Free ad',
    'banner-type-mcbanner': 'Search banner',
    'banner-type-mobile_content': 'Ads for mobile apps',
    'banner-type-performance': 'Smart banner',
    'banner-type-text': 'Text & Image ad',
    'banner-type-text-mobile': 'Mobile Text & Image Ad',
    callouts: 'Callouts',
    'callouts-resource-name': 'callouts',
    'callouts-resource-rejected': "Callouts didn't pass moderation",
    'child-age-limit': 'Age restricted baby food',
    'choose-creatives-presets': 'Select from previously created creatives',
    'choose-gallery': 'Select from uploaded creatives',
    contactPerson: 'Client',
    counters: 'Impression counter',
    'cpm-image-creative': 'Creatives',
    'created-creatives': 'Ready-to-use creatives',
    'creative-help': 'Make your own creative {constructor} or add an existing one that {requirements}',
    'creative-help-mc-banner': 'Add a pre-made creative that {requirements}',
    creatives: 'Creatives',
    'creatives-constructor': 'Ad Builder',
    'creatives-ideas': 'Ideas for creatives',
    'creatives-resource-name': 'creatives',
    'creatives-resource-rejected': "Creatives didn't pass moderation",
    default: 'Select',
    'display-href-resource-name': 'display link',
    'display-href-resource-rejected': "Display link didn't pass moderation",
    'draft-status': 'Draft',
    icq: 'ICQ',
    'image-creative': 'Image creatives',
    images: 'Images',
    'images-resource-name': 'image',
    'images-resource-rejected': "Image didn't pass moderation",
    'in-constructor': 'in Ad Builder',
    'is-previous-version-shown': 'Previous version is being served',
    'is-rejected-on-moderation': 'Rejected by moderation',
    jabber: 'Jabber/GTalk',
    link: 'Completely replace link',
    'link-groups-mass-action': 'Change links',
    'link-replace': 'Link section',
    'link-title': 'Link to website or page on social networks',
    mailru: 'MailRu Agent',
    'manually-suspended-status': 'Stopped',
    'moderation-rejected-status': 'Rejected by moderation',
    'moderation-status': 'Under moderation',
    'not-grouped-mass-action': 'Everything else',
    'on-video-creative-close': 'Unsaved changes will be lost. Continue?',
    'organization-title': 'Company from the Yandex Business Directory',
    pixel: 'Yandex.Audience pixel',
    'placement-pages-rejected': 'No suitable billboards selected',
    'preset-adaptive': 'Adaptive template',
    'preset-create-new': 'Create',
    price: 'Price in the ad',
    'rejected-on-moderation-resources': "Didn't pass moderation: {resources}",
    requirements: 'meets the requirements',
    'site-links': 'Sitelinks',
    sitelink: 'Sitelink',
    'sitelinks-resource-name': 'sitelinks',
    'sitelinks-resource-rejected': "Sitelinks didn't pass moderation",
    skype: 'Skype',
    'standard-image': 'Standard image',
    telegram: 'Telegram',
    'temporarly-suspended-status': 'Suspended by monitoring',
    'text-groups-mass-action': 'Ad text',
    'text-path-replace': 'Find and replace',
    tracking: 'Tracking parameters',
    turbo: 'Turbo pages',
    'turbo-gallery': 'Impressions in the turbo gallery',
    'turbo-title': 'Turbo page',
    turbolanding: 'Turbo page',
    'turbolandings-resource-name': 'turbo page',
    'turbolandings-resource-rejected': "Turbo page didn't pass moderation",
    'upload-link': 'Upload from link',
    'upload-local': 'Upload from computer',
    'vcard-resource-name': 'contact information',
    'vcard-resource-rejected': "Contact information didn't pass moderation",
    'vcard-title': 'vCard',
    viber: 'Viber',
    video: 'Video extensions',
    'video-addition': 'Video extension',
    'video-addtions-resource-name': 'video extension',
    'video-addtions-resource-rejected': "Video extension didn't pass moderation",
    'video-body-placeholder': 'Video description',
    'video-creatives': 'Video creatives',
    'video-title-placeholder': 'Video title',
    'visible-domain': 'Domain',
    'visible-link-replace': 'Display links',
    whatsapp: 'Whatsapp',
    'wide-image': 'Wide-format image',
    'yandex-collections': 'Yandex.Collections',
    'yandex-video': 'Yandex.Video'
};
